<template>
  <div>
    <div class="translation-container">
      <TranslationDropdown
        v-if="focusKnowledgeIsMultilinguale"
        class="ml-4"
        :set-languages="caseParameter.setLanguages"
        :label-translations="caseParameter.labelTranslations"
        :editable="!isArchive"
        @set-new-language="$emit('open-set-language-modal', $event)"
        @unset-language="$emit('unset-language', $event)"
        :rightDirectionDropdown="true"
      />
    </div>
    <header class="case-viewer-header col-12 pr-0 mb-4">
      <not-allowed-tooltip
        :user-permissions="userPermissions"
        :disabled="true"
        permission-key="canUpdateContent"
        placement="top"
      >
        <template v-slot:main-content="{ hasPermissions }">
          <CaseViewerHeaderTitle
            :title="caseParameter.label"
            :editable="hasPermissions"
            @update-title="updateLabel"
          />
        </template>
      </not-allowed-tooltip>
      <div class="d-flex align-items-center">
        <CaseViewerHeaderCount
          :case-count="caseParameter.children.length"
          :article-count="typedCounts['Article']"
          :diag-count="typedCounts['Diagnostic']"
        />
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CaseViewerHeaderTitle from './CaseViewerHeaderTitle';
import CaseViewerHeaderCount from './CaseViewerHeaderCount';
import TranslationDropdown from '@/components/TranslationDropdownWrapper';
import NotAllowedTooltip from '@/components/Commons/NotAllowedTooltip';

export default {
  name: 'case-viewer-header',
  props: {
    caseParameter: {
      type: Object,
      required: true,
    },
    typedCounts: {
      type: Object,
      required: true,
    },
    userPermissions: {
      type: Object,
      default: () => {},
    },
    isArchive: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    CaseViewerHeaderTitle,
    CaseViewerHeaderCount,
    TranslationDropdown,
    NotAllowedTooltip,
  },
  computed: {
    availableLanguages() {
      return this.focusKnowledgeLanguages.filter(
        (lang) => !this.caseParameter.setLanguages.includes(lang),
      );
    },
    ...mapGetters('knowledgeModule', [
      'focusKnowledgeLanguages',
      'editingLanguage',
      'focusKnowledgeIsMultilinguale',
    ]),
  },
  methods: {
    openLanguageModal(lang) {
      this.setLanguageModal = true;
      this.language = lang;
    },
    updateLabel(newLabel) {
      this.$emit('update-case', {
        caseId: this.caseParameter.id,
        label: newLabel,
        childrenOrder: this.caseParameter.childrenOrder,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.translation-container {
  margin-left: -4px;
  margin-bottom: 16px;
}
.case-viewer-header {
  border-left: 3px solid $grey-4-mayday;
}
</style>
